/**
 * Convert object to urlencoded string
 * todo: check for arrays and scalar types
 * @param data
 */
export function toUrlEncoded(data) {
    return Object.keys(data)
        .map((k) => encodeURIComponent(k) + '=' + encodeURIComponent(data[k]))
        .join('&');
}
